import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllSettingsAction,
  UpdateSettingsAction,
} from "store/middlewares/settings/settings";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Card, CardContent, CardHeader, CardTitle, Label } from "components/ui";
import { PaginationButton } from "components/atoms";
import { paginationSize } from "utils/validation/ChangeSettingsForm";
// import { CustomLoader } from "components/atoms"; // replaced by <CalendarSettingSkeleton>
import MotionWrapper from "components/atoms/MotionWrapper";
import { CalendarSettingSkeleton } from "components/molecules";

const CalendarSetting = () => {
  const dispatch = useDispatch();
  const { settings, settingsLoading } = useSelector((state) => state.settings);
  const delayTimer = useRef(null);
  const [initialVal, setInitialVal] = useState(null);

  useEffect(() => {
    dispatch(GetAllSettingsAction());
  }, [dispatch]);

  const handleDebouncedChange = (field, val) => {
    formik.setFieldValue(field, val);

    clearTimeout(delayTimer.current);

    delayTimer.current = setTimeout(() => {
      dispatch(UpdateSettingsAction({ ...formik.values, [field]: val }));
    }, 1000);
  };

  useEffect(() => {
    let tempObj = {};

    if (settings) {
      tempObj = {
        calendarShareLimit: settings?.calendar_share_limit,
        eventParticipantLimit: settings?.event_participant_limit,
      };
    }

    setInitialVal(tempObj);
  }, [settings]);

  const SettingsSchema = Yup.object({
    calendarShareLimit: paginationSize,
    eventParticipantLimit: paginationSize,
  });

  const handleSubmit = (values) => {
    dispatch(
      UpdateSettingsAction({
        ...values,
        onSuccess: () => formik.setSubmitting(false),
        onError: () => {
          formik.setSubmitting(false);
        },
      }),
    );
  };

  const formik = useFormik({
    initialValues: initialVal,
    enableReinitialize: true,
    validationSchema: SettingsSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    return () => clearTimeout(delayTimer.current);
  }, []);

  return (
    <>
      {settingsLoading ? (
        // <CustomLoader /> replaced by <CalendarSettingSkeleton />
        <CalendarSettingSkeleton />
      ) : (
        <MotionWrapper variant="fadeUp" duration={0.35}>
          <form onSubmit={formik.handleSubmit}>
            <Card className="min-w-full">
              <CardHeader>
                <CardTitle>Calendar Setting</CardTitle>
              </CardHeader>

              <CardContent className="grid gap-5">
                <div className="flex items-center justify-between flex-wrap lg:flex-nowrap gap-2.5">
                  <Label className="flex w-full max-w-56">
                    Calendar Share Limit
                  </Label>

                  <PaginationButton
                    min={1}
                    val={formik?.values?.calendarShareLimit}
                    onChange={(val) =>
                      handleDebouncedChange("calendarShareLimit", val)
                    }
                  />
                </div>

                <div className="flex items-center justify-between flex-wrap lg:flex-nowrap gap-2.5">
                  <Label className="flex w-full max-w-56">
                    Event Participant Limit
                  </Label>

                  <PaginationButton
                    min={1}
                    val={formik?.values?.eventParticipantLimit}
                    onChange={(val) =>
                      handleDebouncedChange("eventParticipantLimit", val)
                    }
                  />
                </div>
              </CardContent>
            </Card>
          </form>
        </MotionWrapper>
      )}
    </>
  );
};

export default CalendarSetting;